import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { ErrorBoundary, Suspense } from '~components/suspense';

import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';
import { useGet } from '~hooks/useQuery';

import { getListingRedirect } from '~helpers/common';

import { UserContext } from '~contexts/user';

import Hero from '~components/hero';
import Connections, { ConnectionsSkeleton } from '~containers/connections';

import NoResults from './no-results';

const Chats = () => {
  const intl = useIntl();

  useLayout({ type: 'account', displayCities: false });
  useSeo({ id: 'containers.chats.title', defaultMessage: 'Chats' });
  const { user } = useContext(UserContext);

  const listingRedirect = getListingRedirect(user.accountType, user.operations?.address.place_id || user.wish?.address.place_id);

  const {
    data: conversations,
    isLoading,
    isError,
    error,
  } = useGet(
    {
      name: `chats/`,
      requiresAuthentication: true,
      mockFileName: 'chats/get-chats',
      shouldThrowError: true,
      params: {
        'participant-id': user.personId,
      },
    },
    []
  );

  const status =
    conversations && conversations.data && conversations.data.length > 0
      ? 'success'
      : isError && error?.status !== 404
      ? 'error'
      : 'empty';

  return (
    <div className="c-account__main l-container">
      <Hero.Wrapper>
        <Hero.Title>
          {intl.formatMessage({
            id: 'containers.chats.headline',
            defaultMessage: 'My conversations',
          })}
        </Hero.Title>
      </Hero.Wrapper>
      <div className="l-section l-mb2">
        <ErrorBoundary fallback={<h2 className="l-error l-center">Could not fetch conversations data</h2>}>
          <Suspense fallback={<ConnectionsSkeleton itemCount={2} />} isLoading={isLoading}>
            {status === 'success' && <Connections connections={conversations.data} accountType={user.accountType} />}
            {status === 'error' && <h2 className="l-error l-center">Could not fetch conversations data</h2>}
            {status === 'empty' && <NoResults accountType={user.accountType} listingRedirect={listingRedirect} />}
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Chats;
